import {AppType, appType} from "../helper/appInfo.js";
import type {FunctionImplementation} from "@otto-ec/global-resources/nexus";
import {sharing, type Sharing} from "./index.js";

export interface NativeShareOptions {
    /**
 *
 */
    url: string;
    /**
 *
 */
    type: string;
}

export const shareNative = function shareNative(data) {
    if (appType() == AppType.ANDROID) {
        window.o_apps_android?.shareNative?.(data.url, data.type)
    } else if (appType() == AppType.IOS) {
        window.webkit?.messageHandlers?.shareNative?.postMessage(data);
    }
} satisfies FunctionImplementation<Sharing["shareNative"]>

sharing.assignNamespace({shareNative})